import { AspectRatio, Box } from '@mantine/core'

import { NextImageWrap } from 'components/atoms/imageWrap'
import { useIsMobile } from 'hooks/useIsMobile'
import { ScheduleEventCard } from 'interfaces/types'

import useStyles from './index.styles'
import { HighlightEventStatus } from '..'

export const Banner = ({
  event,
  status,
  handleOnClick,
  ...props
}: {
  handleOnClick: (
    event: ScheduleEventCard,
    status: HighlightEventStatus,
  ) => void
  event: ScheduleEventCard
  status: HighlightEventStatus
}) => {
  const isMobile = useIsMobile()
  const { classes } = useStyles(undefined, {
    name: 'ScheduleEvent__UpcommingBanner__Banner',
  })
  return (
    <Box
      component="a"
      href={status === 'live' ? event.ctaUrl : '#'}
      target="_blank"
      className={classes.thumbFrame}
      {...props}
      onClick={(e) => {
        e.preventDefault()
        handleOnClick(event, status)
      }}
    >
      <AspectRatio ratio={isMobile ? 1 : 728 / 224}>
        <NextImageWrap
          alt={event.title || ''}
          src={isMobile ? event.bannersMobile : event.bannersDesktop}
          loading="lazy"
          className={classes.img}
          fill
        />
      </AspectRatio>
    </Box>
  )
}
